export default {
  IN_PROGRESS: 1,
  INVALID: 2,
  DONE: 3,
  EMPTY: 4
};
